import { useMemo } from "react";
import { Script, Statement } from "../../lib/api/models";
import { onlineStatementsScriptOS003 } from "../../lib/scripts/onlineStatements/onlineStatementsScripts";

export type StatementByYear = {
  year: string;
  statements: Statement[];
};

type OnlineStatementsScriptDetails = {
  scripts: Script[];
  name: string;
};

export const useStatementsByYear = (
  statements: Statement[],
): StatementByYear[] => {
  const statementsByYear = useMemo(() => {
    const list: StatementByYear[] = [];
    for (const statement of statements) {
      const [year] = statement.statementDate.split("-");
      const index = list.findIndex((item) => item.year === year);
      // If year does not yet exist, push year with statement
      // Otherwise, add statement to year's list
      if (index < 0) {
        list.push({
          year,
          statements: [statement],
        });
      } else {
        list[index].statements.push(statement);
      }
    }
    return list;
  }, [statements]);

  return statementsByYear;
};

export const useScriptDetails = (
  statements: Statement[],
): OnlineStatementsScriptDetails | undefined => {
  const scriptDetails = useMemo(():
    | OnlineStatementsScriptDetails
    | undefined => {
    if (!statements) {
      return undefined;
    }
    const scripts = onlineStatementsScriptOS003(statements);
    if (scripts.length === 0) {
      return undefined;
    }
    return {
      name: "OS_003",
      scripts,
    };
  }, [statements]);

  return scriptDetails;
};
